import script from "./VideoUploaderDraggableUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoUploaderDraggableUI.vue?vue&type=script&setup=true&lang=ts"

import "./VideoUploaderDraggableUI.vue?vue&type=style&index=0&id=96207068&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96207068"]])

export default __exports__